import { render, staticRenderFns } from "./DueDateIcon.vue?vue&type=template&id=fac15f8e&scoped=true"
import script from "./DueDateIcon.vue?vue&type=script&lang=js"
export * from "./DueDateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac15f8e",
  null
  
)

export default component.exports